import type { SVGProps } from 'react';

const SvgOrderConfirmation = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" {...props}>
    <g fill={props.color} data-name="smart-send-time">
      <path d="m6.17 8.41 1.49 13.65a5 5 0 0 0 2.48 3.69 3.16 3.16 0 0 0-1.05 2.35 3.2 3.2 0 1 0 6.39 0 3.1 3.1 0 0 0-.48-1.68h9.4a3.1 3.1 0 0 0-.49 1.68 3.2 3.2 0 1 0 3.2-3.2H12.62a3.49 3.49 0 0 1-3.46-3h18.47a2.75 2.75 0 0 0 2.73-2.39L31.7 9.29l-1.49-.19-1.34 10.21a1.24 1.24 0 0 1-1.24 1.08H9L7.66 8.24a4.52 4.52 0 0 0-4.48-4h-3v1.5h3a3 3 0 0 1 2.99 2.67m6.12 21.39A1.7 1.7 0 1 1 14 28.1a1.7 1.7 0 0 1-1.71 1.7m16.5-1.7A1.7 1.7 0 1 1 27 26.42h.16a1.7 1.7 0 0 1 1.63 1.68" />
      <path d="m15.42 7.41-1.06 1.06 3.7 3.71a.8.8 0 0 0 .53.22.75.75 0 0 0 .53-.22l10.64-10.6L28.7.52 18.6 10.59Z" />
      <path d="M18.66 18.56A9.05 9.05 0 0 0 27.5 7.48l-1.5.33a8 8 0 0 1 .19 1.69 7.57 7.57 0 1 1-3.29-6.27L23.75 2a9.07 9.07 0 1 0-5.09 16.57Z" />
    </g>
  </svg>
);

export default SvgOrderConfirmation;
